<template>
  <v-menu
    v-if="$store.getters.getSelectedStore"
    v-model="menuControl"
    content-class="stores-menu"
    :close-on-content-click="false"
  >
    <template #activator="{ props, isActive }">
      <v-sheet v-bind="singleStore ? null : props" class="store-sheet">
        <v-row no-gutters align="center" style="cursor: pointer">
          <v-col cols="auto">
            <div class="store-avatar">
              <svg-icon
                src="../../assets/icons/department_store.svg"
                :width="storeAvatarSize"
                :height="storeAvatarSize"
              />
            </div>
          </v-col>
          <v-col cols="9">
            <v-row no-gutters class="store-document-text">
              <span class="store-document-title">CNPJ:</span>
              {{ selectedStoreDocument }}
            </v-row>
            <v-row no-gutters class="store-address">
              {{ selectedStoreAddress }}
            </v-row>
          </v-col>
          <v-col cols="auto" class="d-flex" v-if="!singleStore">
            <google-icon
              class="menu-icon"
              variant="rounded"
              :fill="false"
              :icon="isActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
              :weight="700"
              color="#60758D"
              :size="iconSize"
            ></google-icon>
          </v-col>
        </v-row>
      </v-sheet>
    </template>
    <v-list class="menu-list">
      <v-list-item>
        <v-text-field
          v-model="inputText"
          class="text-field"
          variant="outlined"
          rounded="pill"
          base-color="#B9B9B9"
          :color="baseColor"
          :hide-details="true"
          placeholder="Buscar por nome, endereço ou CNPJ"
        >
          <template #prepend-inner>
            <google-icon
              variant="outlined"
              :fill="false"
              icon="search"
              color="#60758D"
              :weight="700"
              :size="iconSize"
            ></google-icon>
          </template>
        </v-text-field>
      </v-list-item>
      <v-infinite-scroll
        :max-height="infinitySize"
        :items="storeList"
        item-text="address.formatted_address"
        item-value="id"
        @load="load"
      >
        <template v-for="(store, index) in storeList" :key="index">
          <v-row
            no-gutters
            class="store-item-row"
            @click="changeStore(store)"
            :style="{ '--hover-bg': hoverColor }"
          >
            <v-col cols="auto">
              <div
                class="store-avatar"
                :style="{ '--avatar-bg': avatarHoverColor }"
              >
                <svg-icon
                  src="../../assets/icons/department_store.svg"
                  :width="storeAvatarSize"
                  :height="storeAvatarSize"
                />
              </div>
            </v-col>
            <v-col cols="auto">
              <v-row no-gutters class="store-document-text">
                <span class="store-document-title">CNPJ:</span>
                {{ formatedStoreDocument(store) }}
              </v-row>
              <v-row no-gutters class="store-address">
                {{ formatedStoreAddress(store) }}
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template #empty>
          <v-row v-if="showLottie" no-gutters class="empty-text">
            <v-col cols="auto">
              <DotLottieVue
                :style="`height: ${allLoadIconSize}; width: ${allLoadIconSize}`"
                autoplay
                src="../assets/animated/Done.json"
              />
            </v-col>
            <v-col cols="auto">Todas filiais foram carregadas!</v-col>
          </v-row>
        </template>
      </v-infinite-scroll>
    </v-list>
  </v-menu>
</template>
<script>
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";

export default {
  name: "StoreSelector",
  components: { DotLottieVue },
  data: () => ({
    inputText: null,
    menuControl: false,
    showLottie: false
  }),
  mounted() {},
  methods: {
    async load({ done }) {
      if (this.hasNextPage) {
        const result = await this.$store.dispatch("loadStores");

        if (result.success) {
          done("ok");
        } else {
          console.log("Erro ao carregar dados das lojas");
        }
      } else {
        setTimeout(() => {
          this.showLottie = true;
        }, 200);
        done("empty");
      }
    },
    formatedStoreDocument(store) {
      return store.cnpj.replace(
        /(.{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    },
    formatedStoreAddress(store) {
      const store_address = store.address.formatted_address.split(", ");
      return (
        store_address[0] + ", " + store_address[1] + ", " + store_address[3]
      );
    },
    changeStore(store) {
      this.menuControl = false;
      this.$store.commit("setSelectedStore", store);
    },
    normalizeString(str) {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    expandMenu(status) {
      this.menuControl = status;
    }
  },
  computed: {
    storeData() {
      return this.$store.getters.getSelectedStore;
    },
    selectedStoreDocument() {
      return this.storeData.cnpj.replace(
        /(.{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    },
    selectedStoreAddress() {
      return this.storeData.address.formatted_address;
    },
    storeAvatarSize() {
      switch (true) {
        case this.$store.getters.isTabletLandscape:
          return "4vw";
        case this.$store.getters.isTabletPortrait:
          return "5vh";
        case this.$store.getters.isMobilePortrait:
          return "6vh";
        case this.$store.getters.isMobileLandscape:
          return "6vw";
        default:
          return "3vw";
      }
    },
    iconSize() {
      switch (true) {
        case this.$store.getters.isTabletLandscape:
          return "2vw";
        case this.$store.getters.isTabletPortrait:
          return "2.5vh";
        case this.$store.getters.isMobilePortrait:
          return "3vh";
        case this.$store.getters.isMobileLandscape:
          return "3vw";
        default:
          return "1.5vw";
      }
    },
    allLoadIconSize() {
      switch (true) {
        case this.$store.getters.isTabletLandscape:
          return "7vw";
        case this.$store.getters.isTabletPortrait:
          return "7vh";
        case this.$store.getters.isMobilePortrait:
          return "10vh";
        case this.$store.getters.isMobileLandscape:
          return "10vw";
        default:
          return "5vw";
      }
    },
    infinitySize() {
      switch (true) {
        case this.$store.getters.isTabletLandscape:
          return "25vw";
        case this.$store.getters.isTabletPortrait:
          return "25vh";
        case this.$store.getters.isMobilePortrait:
          return "50vh";
        case this.$store.getters.isMobileLandscape:
          return "25vw";
        default:
          return "25vw";
      }
    },
    singleStore() {
      return this.$store.getters.getStores.length === 1;
    },
    storeList() {
      if (!this.inputText) {
        return this.$store.getters.getStores;
      } else {
        const search_term = this.normalizeString(this.inputText);

        const filter_stores = this.$store.getters.getStores.filter((item) => {
          // Verifica apenas os atributos name, cnpj e formatted_address
          return (
            this.normalizeString(item.name).includes(search_term) ||
            this.normalizeString(item.cnpj).includes(search_term) ||
            this.normalizeString(item.address.formatted_address).includes(
              search_term
            )
          );
        });

        if (filter_stores.length === 0) {
          this.load({ done: () => {} });
        }

        return filter_stores;
      }
    },
    hasNextPage() {
      const total = this.$store.getters.getAvailableStores;

      return total > this.storeList.length;
    },
    mobileTabletPortrait() {
      return (
        this.$store.getters.isMobile || this.$store.getters.isTabletPortrait
      );
    },
    isFTX4() {
      return this.$store.getters.isFTX4;
    },
    hoverColor() {
      return this.colors.selectHover;
    },
    avatarHoverColor() {
      return this.colors.hover;
    },
    colors() {
      return this.$vuetify.theme.global.current.colors;
    },
    baseColor() {
      return this.colors.primary;
    }
  },
  watch: {
    menuControl(value) {
      if (!value) {
        this.showLottie = false;
      }
    }
  }
};
</script>
<style src="@/styles/global.css"></style>
<style scoped>
/* CSS para versão Desktop */
@media (min-width: 1200px) and (orientation: landscape) {
  .store-sheet {
    margin-right: 2vw;
  }
  .store-avatar {
    /*padding: 0.5vw;*/
    border: 0.1vw solid #e6e6e6;
    border-radius: 50%;
    margin-right: 1vw;
  }
  .store-document-title {
    font-size: 0.8vw !important;
    font-weight: 600;
    line-height: 1.2vw;
    letter-spacing: 0vw;
    color: #60758d;
    margin-right: 0.5vw;
  }
  .store-document-text {
    font-size: 0.8vw !important;
    font-weight: 600;
    line-height: 1.2vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .store-address {
    font-size: 0.8vw !important;
    font-weight: 400;
    line-height: 1.2vw;
    letter-spacing: 0vw;
    color: #60758d;
    text-align: left;
  }
  .menu-icon {
    margin-left: 1vw;
  }
  .menu-list {
    padding: 1vw 0vw;
    border-radius: 2vw !important;
    margin-top: 1vw;
  }
  .store-item-row {
    align-items: center;
    cursor: pointer;
    padding: 1vw;
    flex-grow: 0;
    margin-left: 1vw !important;
    margin-right: 1vw !important;
  }
  .empty-text {
    font-size: 1vw !important;
    font-weight: 600;
    line-height: 1.2vw;
    letter-spacing: 0vw;
    color: #314050;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

/* CSS para versão Tablet na horizontal */
@media (max-width: 1200px) and (min-height: 600px) and (orientation: landscape) {
  .store-sheet {
    margin-right: 2vw;
  }
  .store-avatar {
    /*padding: 0.8vw;*/
    border: 0.1vw solid #e6e6e6;
    border-radius: 50%;
    margin-right: 1vw;
  }
  .store-document-title {
    font-size: 1.2vw !important;
    font-weight: 600;
    line-height: 1.5vw;
    letter-spacing: 0vw;
    color: #60758d;
    margin-right: 0.5vw;
  }
  .store-document-text {
    font-size: 1.2vw !important;
    font-weight: 600;
    line-height: 1.5vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .store-address {
    font-size: 1.2vw !important;
    font-weight: 400;
    line-height: 1.5vw;
    letter-spacing: 0vw;
    color: #60758d;
  }
  .menu-icon {
    margin-left: 1vw;
  }
  .menu-list {
    padding: 1vw 0vw;
    border-radius: 2vw !important;
    margin-top: 1vw;
  }
  .store-item-row {
    align-items: center;
    cursor: pointer;
    padding: 1vw;
    flex-grow: 0;
    margin-left: 1vw !important;
    margin-right: 1vw !important;
  }
  .empty-text {
    font-size: 1.5vw !important;
    font-weight: 600;
    line-height: 1.8vw;
    letter-spacing: 0vw;
    color: #314050;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

/* CSS para versão Tablet na vertical */
@media (min-width: 600px) and (orientation: portrait) {
  .store-sheet {
    margin-right: 2vh;
  }
  .store-avatar {
    /*padding: 0.8vh;*/
    border: 0.1vh solid #e6e6e6;
    border-radius: 50%;
    margin-right: 1vh;
  }
  .store-document-title {
    font-size: 1.5vh !important;
    font-weight: 600;
    line-height: 1.8vh;
    letter-spacing: 0vh;
    color: #60758d;
    margin-right: 0.5vh;
  }
  .store-document-text {
    font-size: 1.5vh !important;
    font-weight: 600;
    line-height: 1.8vh;
    letter-spacing: 0vh;
    color: #314050;
  }
  .store-address {
    font-size: 1.5vh !important;
    font-weight: 400;
    line-height: 1.8vh;
    letter-spacing: 0vh;
    color: #60758d;
    text-align: left;
  }
  .menu-icon {
    margin-left: 1vh;
  }
  .menu-list {
    padding: 2vh 1vh;
    border-radius: 2vh !important;
    margin-top: 1vh;
  }
  .store-item-row {
    align-items: center;
    cursor: pointer;
    padding: 1vh;
    flex-grow: 0;
  }
  .empty-text {
    font-size: 1.5vh !important;
    font-weight: 600;
    line-height: 1.8vh;
    letter-spacing: 0vh;
    color: #314050;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

/* CSS para versão Mobile na horizontal */
@media (max-width: 1024px) and (max-height: 600px) and (orientation: landscape) {
  .store-sheet {
    margin-right: 2vw;
  }
  .store-avatar {
    /*padding: 1.2vw;*/
    border: 0.1vw solid #e6e6e6;
    border-radius: 50%;
    margin-right: 1vw;
  }
  .store-document-title {
    font-size: 2vw !important;
    font-weight: 600;
    line-height: 2.5vw;
    letter-spacing: 0vw;
    color: #60758d;
    margin-right: 0.5vw;
  }
  .store-document-text {
    font-size: 2vw !important;
    font-weight: 600;
    line-height: 2.5vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .store-address {
    font-size: 2vw !important;
    font-weight: 400;
    line-height: 2.5vw;
    letter-spacing: 0vw;
    color: #60758d;
  }
  .menu-icon {
    margin-left: 1vw;
  }
  .menu-list {
    padding: 2vw 1vw;
    border-radius: 2vw !important;
    margin-top: 1vw;
  }
  .store-item-row {
    align-items: center;
    cursor: pointer;
    padding: 1vw;
    flex-grow: 0;
  }
  .empty-text {
    font-size: 2vw !important;
    font-weight: 600;
    line-height: 2.5vw;
    letter-spacing: 0vw;
    color: #314050;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

/* CSS para versão Mobile na vertical */
@media (max-width: 600px) and (orientation: portrait) {
  .store-sheet {
    margin-right: 2vh;
  }
  .store-avatar {
    /*padding: 1vh;*/
    border: 0.1vh solid #e6e6e6;
    border-radius: 50%;
    margin-right: 1vh;
  }
  .store-document-title {
    font-size: 2vh !important;
    font-weight: 600;
    line-height: 2.5vh;
    letter-spacing: 0vh;
    color: #60758d;
    margin-right: 0.5vh;
    text-align: left;
  }
  .store-document-text {
    font-size: 2vh !important;
    font-weight: 600;
    line-height: 2.5vh;
    letter-spacing: 0vh;
    color: #314050;
    text-align: left;
  }
  .store-address {
    font-size: 2vh !important;
    font-weight: 400;
    line-height: 2.5vh;
    letter-spacing: 0vh;
    color: #60758d;
    text-align: left;
    text-wrap: balance;
  }
  .menu-icon {
    margin-left: 1vh;
  }
  .menu-list {
    padding: 2vh 1vh;
    border-radius: 2vh !important;
    margin-top: 1vh;
  }
  .store-item-row {
    cursor: pointer;
    padding: 1vh;
    flex-grow: 0;
    flex-wrap: nowrap;
    align-items: flex-start;
  }
  .empty-text {
    font-size: 2vh !important;
    font-weight: 600;
    line-height: 2.5vh;
    letter-spacing: 0vh;
    color: #314050;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.store-item-row:hover {
  background-color: var(--hover-bg);
  border-radius: 1vw;
}
.store-item-row:hover .store-avatar {
  background-color: var(--avatar-bg);
}
</style>
<style></style>
